import { Serializable } from '@core/models';
import i18n from '@core/plugins/i18n';
import { DEFAULT_LOCALE } from '@core/constants';

export class DaoModel extends Serializable {
  constructor(guid = null) {
    super();
    this.guid = guid;
  }

  serialize() {
    return {
      guid: this.guid
    };
  }

  translateAttribute(attribute) {
    const localizedAttr = this[`${attribute}_${i18n.locale}`];
    if (!localizedAttr) return this[`${attribute}_${DEFAULT_LOCALE}`];
    return localizedAttr;
  }

  translateAttributeCamel(attribute) {
    const i18Locale = i18n.locale.replace(/(\w)(\w*)/g,
      (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase());
    const defaultLocale = DEFAULT_LOCALE.replace(/(\w)(\w*)/g,
      (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase());
    const localizedAttr = this[`${attribute}${i18Locale}`];
    if (!localizedAttr) return this[`${attribute}${defaultLocale}`];
    return localizedAttr;
  }
}
